<!-- MIT License

Copyright (c) 2024 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->
<span class="cipher-info">
  <h1 mat-dialog-title class="header">Cipher Armor Info</h1>
  <div class="scroller">
    <div mat-dialog-content class="dialog-content">
      @if (error) {
        <p>{{ error }}</p>
      }
      @if (!error) {
        <div class="dialog-body">
          <ul class="tech-list">
            <li><b>Cipher and Mode:</b></li>
            <li><b>PBKDF2 Iterations:</b></li>
            <li><b>Derived Keys:</b></li>
            @if (hint) {
              <li><b>Password Hint:</b></li>
            }
            <li><b>Loops:</b></li>
            <li><b>Version:</b></li>
          </ul>
          <ul class="tech-list">
            <li>{{ alg }}</li>
            <li>{{ ic }}</li>
            <!-- hard-coded -->
            <li>256-bit</li>
            @if (hint) {
              <li>{{ hint }}</li>
            }
            <li>{{ lps }}</li>
            <li>{{ ver }}</li>
          </ul>
        </div>
      }
    </div>
  </div>
  <!--last so it doesn't get focus-->
  <button class="close-button3" matSuffix mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</span>
